import service from '@/utils/request'

// 获取标签列表
export const getCustomTagList = (data) => {
  return service({
    url: '/uSysCustomTag/list',
    method: 'post',
    data: data
  })
}

// 创建标签
export const createCustomTag = (data) => {
  return service({
    url: '/uSysCustomTag/create',
    method: 'post',
    data: data
  })
}

// 更新标签
export const updateCustomTag = (data) => {
  return service({
    url: '/uSysCustomTag/update',
    method: 'post',
    data: data
  })
}

// 删除标签
export const deleteCustomTag = (data) => {
  return service({
    url: '/uSysCustomTag/delete',
    method: 'post',
    data: data
  })
}

// 切换标签状态
export const toggleCustomTagStatus = (data) => {
  return service({
    url: '/uSysCustomTag/toggleStatus',
    method: 'post',
    data: data
  })
}

// 获取标签关联用户列表
export const getCustomTagUserList = (data) => {
  return service({
    url: '/uSysCustomTag/userList',
    method: 'post',
    data: data
  })
}

// 手动给用户打标签
export const manualTagUser = (data) => {
  return service({
    url: '/uSysCustomTag/manualTag',
    method: 'post',
    data: data
  })
}

// 移除用户标签
export const removeUserTag = (data) => {
  return service({
    url: '/uSysCustomTag/removeUserTag',
    method: 'post',
    data: data
  })
}

// 获取标签统计数据
export const getCustomTagStatistics = (data) => {
  return service({
    url: '/uSysCustomTag/statistics',
    method: 'post',
    data: data
  })
}

// ============ 标签组相关 API ============

// 获取标签组列表
export const getTagGroupList = (data) => {
  return service({
    url: '/uSysCustomTagGroup/list',
    method: 'post',
    data: data
  })
}

// 创建标签组
export const createTagGroup = (data) => {
  return service({
    url: '/uSysCustomTagGroup/create',
    method: 'post',
    data: data
  })
}

// 更新标签组
export const updateTagGroup = (data) => {
  return service({
    url: '/uSysCustomTagGroup/update',
    method: 'post',
    data: data
  })
}

// 删除标签组
export const deleteTagGroup = (data) => {
  return service({
    url: '/uSysCustomTagGroup/delete',
    method: 'post',
    data: data
  })
}

// 激活标签组
export const activateTagGroup = (data) => {
  return service({
    url: '/uSysCustomTagGroup/activate',
    method: 'post',
    data: data
  })
}

// 添加标签到标签组
export const addTagsToGroup = (data) => {
  return service({
    url: '/uSysCustomTagGroup/addTags',
    method: 'post',
    data: data
  })
}

// 从标签组移除标签
export const removeTagsFromGroup = (data) => {
  return service({
    url: '/uSysCustomTagGroup/removeTags',
    method: 'post',
    data: data
  })
}

// 获取标签组内的标签列表
export const getGroupTags = (data) => {
  return service({
    url: '/uSysCustomTagGroup/getGroupTags',
    method: 'post',
    data: data
  })
}

// 获取标签所在的标签组列表
export const getTagGroups = (data) => {
  return service({
    url: '/uSysCustomTagGroup/getTagGroups',
    method: 'post',
    data: data
  })
}
